import { render, staticRenderFns } from "./addAds.vue?vue&type=template&id=648aff32&lang=pug"
import script from "./addAds.vue?vue&type=script&lang=js"
export * from "./addAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports